._headerScrollIcon_jvdbo_1 {
  transform: rotate(90deg); }
